import {CategoryFormComponent} from "../component/category.form.component";
import {useCategoryRepository} from "../../../../../domain/repository/category.repository";
import {ModulePageProps} from "../../../core/module-pages";
import {JbPageHeaderComponent} from "../../../core/component/jb-page-header.component";
import {useEffect, useState} from "react";
import {CategoryEntity} from "../../../../../domain/entity/category.entity";
import {useParams} from "react-router-dom";

export function EditCategoryPage(props: ModulePageProps) {
  const [category, setCategory] = useState<CategoryEntity>();
  const { id } = useParams<any>()
  
  const categoryRepo = useCategoryRepository();
  
  useEffect(() => {
    categoryRepo.find(id).then(res => setCategory(res.data));
  }, [id]);
  
  function onSave(values: any) {
    categoryRepo.edit(id, values).then(() => {
      props.navigator('list')
    })
  }
  
  return (
    <>
      <JbPageHeaderComponent title={'Nova Categoria'} />
      <CategoryFormComponent
        onSubmit={onSave}
        currentValues={category}
        onCancel={() => props.navigator('list')}
      />
    </>
  )
}